import AWS, { Config } from 'aws-sdk';
import {
  CognitoUserPool,
  CognitoUser
} from 'amazon-cognito-identity-js';

function confirm(username, token, password, config) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.UserPoolId,
    ClientId: config.ClientId,
  });

  const userData = {
    Username : username,
    Pool : userPool
  };

  Config.region = config.region;
  const cognitoUser = new CognitoUser(userData);
  const prom = new Promise((resolve, reject) => {
    cognitoUser.confirmPassword(token, password, {
      onSuccess: (result) => { resolve(result); },
      onFailure: (error) => { reject(error); },
    });
  });
  return prom;
}

export default function confirmPassword(username, token, password, config) {
  console.log(`confirm password action: ${username}`);
  return dispatch => dispatch({
    type: 'CONFIRM_PASSWORD_FETCH',
    payload: confirm(username, token, password, config)
  });
}



// WEBPACK FOOTER //
// ./src/actions/confirmPassword.js